export default __webpack_public_path__ + "static/media/pedido-doacao.a3a0b745.png";